export const PAYMENT_TYPE = {
  cash: 1,
  invoice: 2,
  cashWorkshop: 3,
} as const;

export type PAYMENT_TYPE_UNION = (typeof PAYMENT_TYPE)[keyof typeof PAYMENT_TYPE];

/**
 * Maps internal payment types to Trusted Shops payment type strings
 * Used for Trusted Shops review email integration
 */
export const PAYMENT_TYPE_TO_TRUSTED_SHOPS: Record<number, string> = {
  [PAYMENT_TYPE.cash]: 'PREPAYMENT',
  [PAYMENT_TYPE.invoice]: 'INVOICE',
  [PAYMENT_TYPE.cashWorkshop]: 'PREPAYMENT',
};

export interface IPaymentConfig {
  status: 'active' | 'inactive';
  paymentMethods: IPaymentMethod[];
}

export interface IPaymentMethod {
  id: string;
  name: string;
  description: string;
  image: string;
}

export interface IPaymentRequest {
  type: PAYMENT_TYPE_UNION;
  paymentUrl?: string;
  payId?: string;
}

export type Status = 'pending' | 'success' | 'failed';

export interface IPaymentStatus {
  available: boolean;
  status: Status;
  orderId?: string;
  reference?: string;
  amount?: number;
  createdAt?: string;
  updatedAt?: string;
}
